var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{ fill:currentcolor;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/moneys"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/moneys_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moneys"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.17 6.64002C18.74 4.47002 17.13 3.52002 14.89 3.52002H6.10996C3.46996 3.52002 1.70996 4.84002 1.70996 7.92002V13.07C1.70996 15.29 2.61996 16.59 4.11996 17.15C4.33996 17.23 4.57996 17.3 4.82996 17.34C5.22996 17.43 5.65996 17.47 6.10996 17.47H14.9C17.54 17.47 19.3 16.15 19.3 13.07V7.92002C19.3 7.45002 19.26 7.03002 19.17 6.64002ZM5.52996 12C5.52996 12.41 5.18996 12.75 4.77996 12.75C4.36996 12.75 4.02996 12.41 4.02996 12V9.00002C4.02996 8.59002 4.36996 8.25002 4.77996 8.25002C5.18996 8.25002 5.52996 8.59002 5.52996 9.00002V12ZM10.5 13.14C9.03996 13.14 7.85996 11.96 7.85996 10.5C7.85996 9.04002 9.03996 7.86002 10.5 7.86002C11.96 7.86002 13.14 9.04002 13.14 10.5C13.14 11.96 11.96 13.14 10.5 13.14ZM16.96 12C16.96 12.41 16.62 12.75 16.21 12.75C15.8 12.75 15.46 12.41 15.46 12V9.00002C15.46 8.59002 15.8 8.25002 16.21 8.25002C16.62 8.25002 16.96 8.59002 16.96 9.00002V12Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.3 10.92V16.07C22.3 19.15 20.54 20.48 17.89 20.48H9.11001C8.36001 20.48 7.69001 20.37 7.11001 20.15C6.64001 19.98 6.23001 19.73 5.90001 19.41C5.72001 19.24 5.86001 18.97 6.11001 18.97H14.89C18.59 18.97 20.79 16.77 20.79 13.08V7.92003C20.79 7.68003 21.06 7.53003 21.23 7.71003C21.91 8.43003 22.3 9.48003 22.3 10.92Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.cce56e24a2beca8d180d7714644f10f4.svg";
export { ForwardRef as ReactComponent };